import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { localizable } from '../Localization';
import {
  Dialog,
  DialogType,
  DialogFooter,
} from 'office-ui-fabric-react/lib/Dialog';
import {
  PrimaryButton,
  DefaultButton,
} from 'office-ui-fabric-react/lib/Button';
import { observer } from 'mobx-react';

@localizable
@observer
export default class PromptDialog extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    onClose: PropTypes.func,
    title: PropTypes.string.isRequired,
    message: PropTypes.string,
  };

  handleSubmit = () => {
    const { onSubmit } = this.props;
    if (onSubmit) {
      onSubmit();
    }
  };

  render() {
    const {
      onClose,
      title,
      message,
      t,
      opened,
      dialogProps,
      showPrimaryButton = true,
      disablePrimaryButton = false,
      defaultButtonText,
    } = this.props;
    return (
      <Dialog
        hidden={!opened}
        onDismiss={onClose}
        dialogContentProps={{
          type: DialogType.largeHeader,
          title: title,
          subText: message,
        }}
        modalProps={{
          titleAriaId: 'myLabelId',
          subtitleAriaId: 'mySubTextId',
          isBlocking: true,
          containerClassName: 'ms-dialogMainOverride',
        }}
        {...dialogProps}
      >
        {this.props.children}
        <DialogFooter>
          {showPrimaryButton ? (
            <PrimaryButton
              onClick={this.handleSubmit}
              text={t('Yes')}
              disabled={disablePrimaryButton}
            />
          ) : null}
          <DefaultButton
            onClick={onClose}
            text={defaultButtonText || t('No')}
          />
        </DialogFooter>
      </Dialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/Prompt/index.jsx